var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import _cloneDeep from "lodash/cloneDeep";
import _defaultsDeep from "lodash/defaultsDeep";
import { LoggingModule } from "@pns-fe/sdk-common-modules";
import { StorageName } from "../../../constants/sdk";
const DATA_TEMPLATE = {
  data: {},
  timestamp: 0
};
class BaseStorageWrapper {
  constructor(name = "BaseStorageWrapper") {
    this._getConsentData = ({
      userInfo,
      entityKeys,
      collectionPointId
    }) => {
      var _a, _b, _c, _d;
      LoggingModule.info(`[${this.name}]: _getConsentData`, {
        userInfo,
        entityKeys,
        collectionPointId
      });
      const data = {
        entityMap: null,
        collectionPoint: null
      };
      try {
        const store = this.getConsentStore(userInfo);
        const entityStorage = store[StorageName.ENTITIES];
        const collectionPointStorage = store[StorageName.COLLECTION_POINTS];
        let collectionPointEntityKeys = [];
        if (collectionPointId) {
          data.collectionPoint = ((_a = collectionPointStorage == null ? void 0 : collectionPointStorage.data) == null ? void 0 : _a[collectionPointId]) ? _cloneDeep(collectionPointStorage.data[collectionPointId]) : null;
          collectionPointEntityKeys = (_c = (_b = data.collectionPoint) == null ? void 0 : _b.entity_keys) != null ? _c : [];
        }
        data.entityMap = _cloneDeep((_d = entityStorage == null ? void 0 : entityStorage.data) != null ? _d : {});
        const fullKeys = Object.keys(data.entityMap);
        if (fullKeys.length) {
          if (collectionPointId) {
            const entityMap = {};
            collectionPointEntityKeys.forEach((key) => {
              var _a2;
              if ((_a2 = data.entityMap) == null ? void 0 : _a2[key]) {
                entityMap[key] = data.entityMap[key];
              }
            });
            data.entityMap = entityMap;
          } else if (entityKeys == null ? void 0 : entityKeys.length) {
            const entityMap = {};
            entityKeys.forEach((key) => {
              var _a2;
              if ((_a2 = data.entityMap) == null ? void 0 : _a2[key]) {
                entityMap[key] = data.entityMap[key];
              }
            });
            data.entityMap = entityMap;
          }
        }
      } catch (e) {
        LoggingModule.error(`[${this.name}]: getConsentData Error`, {
          userInfo,
          entityKeys,
          collectionPointId,
          error: e
        });
      }
      return data;
    };
    this._updateUserInfo = (deviceId, userId) => {
      LoggingModule.info(`[${this.name}]: _updateUserInfo`, {
        userId,
        deviceId
      });
      this._did = deviceId;
      this._uid = userId;
    };
    this._formatConsentRecord = (entity) => {
      const { key, record, version } = entity != null ? entity : {};
      if (record && key) {
        const consentRecord = __spreadValues({
          // @ts-ignore backfill entity key and version if there isn't any
          entity_key: key,
          entity_version: version
        }, record);
        return consentRecord;
      } else {
        return null;
      }
    };
    this.getUserInfo = () => {
      return {
        device_id: this._did,
        user_id: this._uid
      };
    };
    this.cleanUpUnrelatedUserData = (userInfo) => {
      LoggingModule.info(`[${this.name}]: cleanUpUnrelatedUserData`, {
        userInfo
      });
      const { device_id: deviceId = "", user_id: userId = "" } = userInfo != null ? userInfo : {};
      if (!deviceId && !userId || deviceId !== this._did || userId !== this._uid) {
        this.cleanConsentData();
        this._updateUserInfo(deviceId, userId);
      }
    };
    this.insertDataByStorageName = (store, storageName, data, timestamp) => {
      LoggingModule.info(`[${this.name}]: insertDataByStorageName`, {
        data,
        storageName,
        timestamp
      });
      const { data: prevData = {}, timestamp: prevTimestamp = 0 } = store[storageName];
      if (prevTimestamp < timestamp) {
        const newData = _defaultsDeep({}, data, prevData);
        store[storageName] = { data: newData, timestamp };
      }
    };
    this.getNotificationData = (userInfo) => {
      LoggingModule.info(`[${this.name}]: getNotificationData`, {
        userInfo
      });
      const store = this.getNotificationStore(userInfo);
      return store.notification.data;
    };
    this.insertConsentDataIntoStore = (data, timestamp, userInfo) => {
      LoggingModule.info(`[${this.name}]: insertConsentDataIntoStore`, {
        userInfo,
        data,
        timestamp
      });
      const store = this.getConsentStore(userInfo);
      const { entityMap, collectionPoint } = data;
      if ((userInfo == null ? void 0 : userInfo.user_id) || (userInfo == null ? void 0 : userInfo.device_id)) {
        this.insertDataByStorageName(store, StorageName.ENTITIES, entityMap, timestamp);
        if (collectionPoint == null ? void 0 : collectionPoint.id) {
          this.insertDataByStorageName(
            store,
            StorageName.COLLECTION_POINTS,
            {
              [collectionPoint.id]: collectionPoint
            },
            timestamp
          );
        }
      }
      return store;
    };
    this.getRecord = (key, userInfo) => {
      var _a;
      LoggingModule.info(`[${this.name}]: getRecord`, {
        userInfo,
        key
      });
      const { entityMap } = this._getConsentData({ userInfo, entityKeys: [key] });
      const entity = entityMap == null ? void 0 : entityMap[key];
      const consentRecord = (_a = this._formatConsentRecord(entity)) != null ? _a : null;
      if (!consentRecord) {
        LoggingModule.info(`[${this.name}]: getRecord - no record for ${key}`, {
          key
        });
      }
      return {
        record: consentRecord
      };
    };
    this.getEntity = (key, userInfo) => {
      var _a;
      LoggingModule.info(`[${this.name}]: getEntity`, {
        userInfo,
        key
      });
      const { entityMap } = this._getConsentData({ userInfo, entityKeys: [key] });
      const entity = (_a = entityMap == null ? void 0 : entityMap[key]) != null ? _a : null;
      if (!entity) {
        LoggingModule.info(`[${this.name}]: getEntity - no entity for ${key}`, {
          key
        });
      }
      return {
        entity
      };
    };
    this.getEntities = (keys, userInfo) => {
      LoggingModule.info(`[${this.name}]: getEntities`, {
        userInfo,
        keys
      });
      const { entityMap } = this._getConsentData({ userInfo, entityKeys: keys });
      return {
        entityMap
      };
    };
    this.getRecords = (keys, userInfo) => {
      LoggingModule.info(`[${this.name}]: getRecords`, {
        userInfo,
        keys
      });
      const records = [];
      const { entityMap } = this._getConsentData({ userInfo, entityKeys: keys });
      if (keys == null ? void 0 : keys.length) {
        const missingKeys = [];
        keys.forEach((key) => {
          const entity = entityMap == null ? void 0 : entityMap[key];
          const consentRecord = this._formatConsentRecord(entity);
          if (consentRecord) {
            records.push(consentRecord);
          } else {
            missingKeys.push(key);
          }
        });
        if (missingKeys.length) {
          LoggingModule.info(`[${this.name}]: getRecords - missing some records`, {
            entityKeys: missingKeys
          });
        }
      } else {
        Object.keys(entityMap != null ? entityMap : {}).forEach((key) => {
          const consentRecord = this._formatConsentRecord(entityMap == null ? void 0 : entityMap[key]);
          if (consentRecord) {
            records.push(consentRecord);
          }
        });
      }
      return {
        records
      };
    };
    this.getCollectionPoint = (collectionPointId, userInfo) => {
      LoggingModule.info(`[${this.name}]: getCollectionPoint`, {
        userInfo,
        collectionPointId
      });
      const data = this._getConsentData({ userInfo, collectionPointId });
      return data;
    };
    this.clean = () => {
      this.cleanConsentData();
      this.cleanNotificationData();
    };
    this.destruct = () => {
      this.clean();
    };
    this.name = name;
  }
}
var BaseStorageWrapper_default = BaseStorageWrapper;
export {
  DATA_TEMPLATE,
  BaseStorageWrapper_default as default
};
